module.exports = __webpack_public_path__ + "media/images/product-img-04-362be10e5a2d42f633007dfdacd6edb6.jpg";